// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.rules-list[data-v-0bee0305] {
  list-style: disc inside;
  position: relative;
  font-size: 14px;
}
#rules-label[data-v-0bee0305] {
  text-align: left;
  float: left;
  position: absolute;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/components/rulesContainer.vue"],"names":[],"mappings":";AAmBA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["<template>\n  <br>\n  <p id=\"rules-label\"> {{ ruleLabel }} </p>\n  <br>\n  <div id=\"rules-container\">\n    <ul class=\"rules-list\">\n      <li v-for=\"rule in rules\">\n        {{ rule }}\n      </li>\n    </ul>\n  </div>\n</template>\n\n<script setup>\nconst ruleLabel = window.PassRulesLabel[0];\nconst rules = window.PassRules;\n</script>\n\n<style scoped>\n.rules-list {\n  list-style: disc inside;\n  position: relative;\n  font-size: 14px;\n}\n\n#rules-label {\n  text-align: left;\n  float: left;\n  position: absolute;\n  font-size: 14px;\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
